import { _ } from "../../core/polyglot/polyglot.js";
import { configureDialog } from "../../core/widgets/dialogs/dialogs.js";
import { notBlank } from "../../core/widgets/forms/validators.js";
import AccountingCoordinator from "../shared/documentInfrastructure/AccountingCoordinator.js";

/**
 * Coordinator for the Forecast on-boarding. It provides the callbacks when the wizard is done/cancelled.
 */
export default class ForecastOnBoardingDocumentCoordinator extends AccountingCoordinator {
	_setupContentCallbacks() {
		return {
			onSuccess: () => {
				this._showForecastCreationDialog({
					onSuccess: async ({ model }) => {
						await this._documentState.updateDefaultConfiguration();

						const forecastTemplate =
							await this._documentState.createForecastTemplate({
								model,
							});

						this._redirectTo(
							`forecast-editor/${forecastTemplate.getId()}`,
						);
					},
				});
			},
			onAbort: () => {
				this._redirectTo("forecast-archive");
			},
		};
	}

	_showForecastCreationDialog({ onSuccess }) {
		const model = {};

		configureDialog({
			title: _("Create a forecast template"),
			okLabel: _("Create"),
			formSpec: {
				model,
				saveAction: () => onSuccess({ model }),
			},
			formBuilder: (form) => {
				form.input({
					name: "name",
					attribute: "name",
					label: _("Template name"),
					validator: notBlank(),
				});
			},
		}).show();
	}
}
